export default {
    start_from: "steps.0-1",
    end_at: "end",
    steps: {
        "steps.0-1": {
            type: "answer",
            name: "steps.0-1",
            base_value: "",

            questions: [
                {
                    name: "questions.0-1-1",
                    answers: [
                        {
                            name: "answers.0-1-1-0",
                            value: 0
                        },
                        {
                            name: "answers.0-1-1-1",
                            value: 1
                        },
                        {
                            name: "answers.0-1-1-2",
                            value: 2
                        },
                        {
                            name: "answers.0-1-1-3",
                            value: 3
                        },
                        {
                            name: "answers.0-1-1-4",
                            value: 4
                        },
                        {
                            name: "answers.0-1-1-5",
                            value: 5
                        },
                        {
                            name: "answers.0-1-1-6",
                            value: 6
                        },
                        {
                            name: "answers.0-1-1-7",
                            value: 7
                        },
                        {
                            name: "answers.0-1-1-8",
                            value: 8
                        },
                    ]
                }
            ],
            results: [
                {
                    description: "{answers}",
                    next: "steps.0-2",
                }
            ],
            next: "steps.0-2"
        },
        "steps.0-2": {
            type: "answer-list",
            base_value: [],
            name: "steps.0-2",

            questions: [
                {
                    name: "questions.0-2-1",
                    multiselect: true,
                    empty: true,
                    answers: [
                        {
                            name: 'answers.0-2-1-11',
                            value: 11
                        },
                        {
                            name: 'answers.0-2-1-12',
                            value: 12
                        },
                        {
                            name: 'answers.0-2-1-13',
                            value: 13
                        },
                        {
                            name: 'answers.0-2-1-14',
                            value: 14
                        },
                        {
                            name: 'answers.0-2-1-15',
                            value: 15
                        },
                        {
                            name: 'answers.0-2-1-16',
                            value: 16
                        },
                        {
                            name: 'answers.0-2-1-17',
                            value: 17
                        },
                        {
                            name: 'answers.0-2-1-21',
                            value: 21
                        },
                        {
                            name: 'answers.0-2-1-22',
                            value: 22
                        },
                        {
                            name: 'answers.0-2-1-23',
                            value: 23
                        },
                        {
                            name: 'answers.0-2-1-24',
                            value: 24
                        },
                        {
                            name: 'answers.0-2-1-25',
                            value: 25
                        },
                        {
                            name: 'answers.0-2-1-26',
                            value: 26
                        },
                        {
                            name: 'answers.0-2-1-27',
                            value: 27
                        },
                        {
                            name: 'answers.0-2-1-28',
                            value: 28
                        },
                        {
                            name: 'answers.0-2-1-29',
                            value: 29
                        },
                        {
                            name: 'answers.0-2-1-30',
                            value: 30
                        },
                        {
                            name: 'answers.0-2-1-41',
                            value: 41
                        },
                        {
                            name: 'answers.0-2-1-42',
                            value: 42
                        },
                        {
                            name: 'answers.0-2-1-43',
                            value: 43
                        },
                        {
                            name: 'answers.0-2-1-44',
                            value: 44
                        },
                        {
                            name: 'answers.0-2-1-45',
                            value: 45
                        },
                        {
                            name: 'answers.0-2-1-46',
                            value: 46
                        },
                        {
                            name: 'answers.0-2-1-47',
                            value: 47
                        },
                        {
                            name: 'answers.0-2-1-48',
                            value: 48
                        },
                        {
                            name: 'answers.0-2-1-50',
                            value: 50
                        },
                        {
                            name: 'answers.0-2-1-61',
                            value: 61
                        },
                        {
                            name: 'answers.0-2-1-62',
                            value: 62
                        },
                        {
                            name: 'answers.0-2-1-63',
                            value: 63
                        },
                        {
                            name: 'answers.0-2-1-64',
                            value: 64
                        },
                        {
                            name: 'answers.0-2-1-70',
                            value: 70
                        },
                    ]
                },
            ],

            results: [
                {
                    description: "{answers}",
                    next: "steps.1-1",
                }
            ],
            next: "steps.1-1"
        },
        "steps.1-1": {
            type: "answer",
            base_value: "",
            name: "steps.1-1",

            questions: [
                {
                    name: "questions.1-1-1",
                    answers: [
                        {
                            name: "answers.yes",
                            value: 1,
                        },
                        {
                            name: "answers.no",
                            value: 0
                        }
                    ]
                }
            ],

            results: [
                {
                    value: "answers.yes",
                    description: "results.1-1",
                    next: "steps.2"
                },
                {
                    value: "answers.no",
                    description: "{answer}",
                    next: "steps.1-2"
                },
            ],
        },
        "steps.1-2": {
            type: "answer",
            base_value: "",
            name: "steps.1-2",

            questions: [
                {
                    name: "questions.1-2-1", //Do you have other kind of experiences in the agricultural filed you wish to become an entrepreneur?
                    answers: [
                        {
                            name: "answers.yes",
                            value: 1,
                        },
                        {
                            name: "answers.no",
                            value: 0
                        }
                    ]
                }
            ],

            results: [
                {
                    value: "answers.no",
                    description: "results.1-2",
                    next: "steps.2"
                },
                {
                    value: "answers.yes",
                    description: "{answer}",
                    next: "steps.1-3"
                },
            ],
        },

        "steps.1-3": { //Do you have other kind of experiences in the agricultural filed you wish to become an entrepreneur?
            type: "answer",
            base_value: "",
            name: "steps.1-3",

            questions: [
                {
                    name: "questions.1-3-1", //What other previous experiences do you have in agriculture ?
                    answers: [
                        {
                            name: "answers.1-3-1-1", //educational experience
                            value: 1,
                        },
                        {
                            name: "answers.1-3-1-2", //volunteer work
                            value: 2
                        },
                        {
                            name: "answers.1-3-1-3", //other experiences
                            value: 3
                        }
                    ]
                }
            ],

            results: [
                {
                    description: "{answer}",
                    next: "steps.1-4"
                }
            ],
        },

        "steps.1-4": { //Do you have other kind of experiences in the agricultural filed you wish to become an entrepreneur?
            type: "score",
            base_value: -1,
            name: "steps.1-4",

            questions: [
                {
                    name: "questions.1-4-1", //How long time did you spend in this position ?
                    answers: [
                        {
                            name: "answers.1-4-1-1", //less than 3 years 
                            value: 0,
                        },
                        {
                            name: "answers.1-4-1-2", //more than 3 years 
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.1-4-2", //How long has it been since you acquire this experience?
                    answers: [
                        {
                            name: "answers.1-4-1-1", //less than 3 years 
                            value: 1,
                        },
                        {
                            name: "answers.1-4-1-2", //more than 3 years 
                            value: 0
                        }
                    ]
                }
            ],

            results: [
                {
                    upTo: 1,
                    description: "results.1-4.score.0-1",
                    next: "steps.2"
                },
                {
                    upTo: 2,
                    description: "results.1-4.score.2",
                    next: "steps.2"
                }
            ],
        },
        "steps.2": {
            type: "score",
            base_value: -1,
            name: "steps.2",

            questions: [
                {
                    name: "questions.2-1",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-2",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-3",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-4",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-5",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-6",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-7",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-8",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-9",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-10",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-11",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-12",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-13",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-14",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-15",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-16",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-17",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-18",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-19",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.2-20",
                    answers: [
                        {
                            name: "answers.s_agree",
                            value: 5
                        },
                        {
                            name: "answers.agree",
                            value: 4
                        },
                        {
                            name: "answers.sw_agree",
                            value: 3
                        },
                        {
                            name: "answers.disagree",
                            value: 2
                        },
                        {
                            name: "answers.s_disagree",
                            value: 1
                        }
                    ]
                },
            ],

            results: [
                {
                    upTo: 39,
                    description: "results.2.score.39",
                    next: "steps.3-1",
                },
                {
                    upTo: 59,
                    description: "results.2.score.59",
                    next: "steps.3-1",
                },
                {
                    upTo: 79,
                    description: "results.2.score.79",
                    next: "steps.3-1"
                },
                {
                    upTo: 100,
                    description: "results.2.score.100",
                    next: "steps.3-1"
                }
            ]
        },
        "steps.3-1": {
            type: "score",
            base_value: -1,
            name: "steps.3-1",

            questions: [
                {
                    name: "questions.3-1-1",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
                {
                    name: "questions.3-1-2",
                    answers: [
                        {
                            name: "answers.never",
                            value: 4
                        },
                        {
                            name: "answers.rarely",
                            value: 3
                        },
                        {
                            name: "answers.often",
                            value: 2
                        },
                        {
                            name: "answers.always",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.3-1-3",
                    answers: [
                        {
                            name: "answers.never",
                            value: 4
                        },
                        {
                            name: "answers.rarely",
                            value: 3
                        },
                        {
                            name: "answers.often",
                            value: 2
                        },
                        {
                            name: "answers.always",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.3-1-4",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
                {
                    name: "questions.3-1-5",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
                {
                    name: "questions.3-1-6",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
                {
                    name: "questions.3-1-7",
                    answers: [
                        {
                            name: "answers.never",
                            value: 4
                        },
                        {
                            name: "answers.rarely",
                            value: 3
                        },
                        {
                            name: "answers.often",
                            value: 2
                        },
                        {
                            name: "answers.always",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.3-1-8",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
                {
                    name: "questions.3-1-9",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
                {
                    name: "questions.3-1-10",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
                {
                    name: "questions.3-1-11",
                    answers: [
                        {
                            name: "answers.never",
                            value: 4
                        },
                        {
                            name: "answers.rarely",
                            value: 3
                        },
                        {
                            name: "answers.often",
                            value: 2
                        },
                        {
                            name: "answers.always",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.3-1-12",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                }, 
                {
                    name: "questions.3-1-13",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
                {
                    name: "questions.3-1-14",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
                {
                    name: "questions.3-1-15",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
                {
                    name: "questions.3-1-16",
                    answers: [
                        {
                            name: "answers.never",
                            value: 4
                        },
                        {
                            name: "answers.rarely",
                            value: 3
                        },
                        {
                            name: "answers.often",
                            value: 2
                        },
                        {
                            name: "answers.always",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.3-1-17",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
                {
                    name: "questions.3-1-18",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
                {
                    name: "questions.3-1-19",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
                {
                    name: "questions.3-1-20",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
                {
                    name: "questions.3-1-21",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
                {
                    name: "questions.3-1-22",
                    answers: [
                        {
                            name: "answers.never",
                            value: 4
                        },
                        {
                            name: "answers.rarely",
                            value: 3
                        },
                        {
                            name: "answers.often",
                            value: 2
                        },
                        {
                            name: "answers.always",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.3-1-23",
                    answers: [
                        {
                            name: "answers.never",
                            value: 4
                        },
                        {
                            name: "answers.rarely",
                            value: 3
                        },
                        {
                            name: "answers.often",
                            value: 2
                        },
                        {
                            name: "answers.always",
                            value: 1
                        }
                    ]
                },
                {
                    name: "questions.3-1-24",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
                {
                    name: "questions.3-1-25",
                    answers: [
                        {
                            name: "answers.never",
                            value: 1
                        },
                        {
                            name: "answers.rarely",
                            value: 2
                        },
                        {
                            name: "answers.often",
                            value: 3
                        },
                        {
                            name: "answers.always",
                            value: 4
                        }
                    ]
                },
            ],

            results: [
                {
                    upTo: 44,
                    description: "results.3-1.score.44",
                    next: "steps.3-2",
                },
                {
                    upTo: 54,
                    description: "results.3-1.score.54",
                    next: "steps.3-2",
                },
                {
                    upTo: 69,
                    description: "results.3-1.score.69",
                    next: "steps.3-2"
                },
                {
                    upTo: 100,
                    description: "results.3-1.score.100",
                    next: "steps.3-2"
                }
            ]
        },
        "steps.3-2": {
            type: "score",
            base_value: -1,
            name: "steps.3-2",

            questions: [
                {
                    name: "questions.3-2-1",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
                {
                    name: "questions.3-2-2",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
                {
                    name: "questions.3-2-3",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
                {
                    name: "questions.3-2-4",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
                {
                    name: "questions.3-2-5",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
            ],

            results: [
                {
                    upTo: 2,
                    description: "results.3-2.score.2",
                    next: "steps.3-3",
                },
                {
                    upTo: 5,
                    description: "results.3-2.score.5",
                    next: "steps.3-3",
                },
                {
                    upTo: 6,
                    description: "results.3-2.score.6",
                    next: "steps.3-3"
                },
                {
                    upTo: 9,
                    description: "results.3-2.score.9",
                    next: "steps.3-3"
                },
                {
                    upTo: 12,
                    description: "results.3-2.score.12",
                    next: "steps.3-3"
                }
            ]
        },
        "steps.3-3": {
            type: "score",
            base_value: -1,
            name: "steps.3-3",

            questions: [
                {
                    name: "questions.3-3-1",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
                {
                    name: "questions.3-3-2",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
                {
                    name: "questions.3-3-3",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
                {
                    name: "questions.3-3-4",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
                {
                    name: "questions.3-3-5",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
            ],

            results: [
                {
                    upTo: 2,
                    description: "results.3-3.score.2",
                    next: "steps.3-4",
                },
                {
                    upTo: 5,
                    description: "results.3-3.score.5",
                    next: "steps.3-4",
                },
                {
                    upTo: 6,
                    description: "results.3-3.score.6",
                    next: "steps.3-4"
                },
                {
                    upTo: 9,
                    description: "results.3-3.score.9",
                    next: "steps.3-4"
                },
                {
                    upTo: 12,
                    description: "results.3-3.score.12",
                    next: "steps.3-4"
                }
            ]
        },
        "steps.3-4": {
            type: "score",
            base_value: -1,
            name: "steps.3-4",

            questions: [
                {
                    name: "questions.3-4-1",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
                {
                    name: "questions.3-4-2",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
                {
                    name: "questions.3-4-3",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
                {
                    name: "questions.3-4-4",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
                {
                    name: "questions.3-4-5",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
            ],

            results: [
                {
                    upTo: 2,
                    description: "results.3-4.score.2",
                    next: "steps.3-5",
                },
                {
                    upTo: 5,
                    description: "results.3-4.score.5",
                    next: "steps.3-5",
                },
                {
                    upTo: 6,
                    description: "results.3-4.score.6",
                    next: "steps.3-5"
                },
                {
                    upTo: 9,
                    description: "results.3-4.score.9",
                    next: "steps.3-5"
                },
                {
                    upTo: 12,
                    description: "results.3-4.score.12",
                    next: "steps.3-5"
                }
            ]
        },
        "steps.3-5": {
            type: "score",
            base_value: -1,
            name: "steps.3-5",

            questions: [
                {
                    name: "questions.3-5-1",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
                {
                    name: "questions.3-5-2",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
                {
                    name: "questions.3-5-3",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
                {
                    name: "questions.3-5-4",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
                {
                    name: "questions.3-5-5",
                    answers: [
                        {
                            name: "answers.true",
                            value: 1
                        },
                        {
                            name: "answers.false",
                            value: 0
                        }
                    ]
                },
            ],

            results: [
                {
                    upTo: 2,
                    description: "results.3-5.score.2",
                    next: "steps.4-1",
                },
                {
                    upTo: 5,
                    description: "results.3-5.score.5",
                    next: "steps.4-1",
                },
                {
                    upTo: 6,
                    description: "results.3-5.score.6",
                    next: "steps.4-1"
                },
                {
                    upTo: 9,
                    description: "results.3-5.score.9",
                    next: "steps.4-1"
                },
                {
                    upTo: 12,
                    description: "results.3-5.score.12",
                    next: "steps.4-1"
                }
            ]
        },
        "steps.4-1": {
            type: "score",
            base_value: -1,
            name: "steps.4-1",
            questions: [
                {
                    name: "questions.4-1-1",
                    answers: [
                        {
                            name: "answers.insecure",
                            value: 5
                        },
                        {
                            name: "answers.confident",
                            value: 7
                        },
                        {
                            name: "answers.indipendent",
                            value: 10
                        },
                        {
                            name: "answers.dontknow",
                            value: 0
                        },
                    ] 
                },
                {
                    name: "questions.4-1-2",
                    answers: [
                        {
                            name: "answers.insecure",
                            value: 5
                        },
                        {
                            name: "answers.confident",
                            value: 7
                        },
                        {
                            name: "answers.indipendent",
                            value: 10
                        },
                        {
                            name: "answers.dontknow",
                            value: 0
                        },
                    ] 
                },
                {
                    name: "questions.4-1-3",
                    answers: [
                        {
                            name: "answers.insecure",
                            value: 5
                        },
                        {
                            name: "answers.confident",
                            value: 7
                        },
                        {
                            name: "answers.indipendent",
                            value: 10
                        },
                        {
                            name: "answers.dontknow",
                            value: 0
                        },
                    ] 
                },
                {
                    name: "questions.4-1-4",
                    answers: [
                        {
                            name: "answers.insecure",
                            value: 5
                        },
                        {
                            name: "answers.confident",
                            value: 7
                        },
                        {
                            name: "answers.indipendent",
                            value: 10
                        },
                        {
                            name: "answers.dontknow",
                            value: 0
                        },
                    ] 
                },
            ],

            results: [ 
                {
                    upTo: 5,
                    description: "results.4-1.score.2",
                    next: "steps.4-2-1",
                },
                {
                    upTo: 8,
                    description: "results.4-1.score.5",
                    next: "steps.4-2-1",
                },
                {
                    upTo: 10,
                    description: "results.4-1.score.10",
                    next: "steps.4-2-1"
                }
            ]
        },
        "steps.4-2-1": {
            type: "answer",
            base_value: "",
            name: "steps.4-2-1",

            questions: [
                {
                    name: "questions.4-2-1",
                    answers: [
                        {
                            name: "answers.yes",
                            value: 1,
                        },
                        {
                            name: "answers.no",
                            value: 0
                        }
                    ]
                }
            ],

            results: [
                {
                    value: "answers.yes",
                    description: "results.4-2-1.yes",
                    next: "steps.4-2-2"
                },
                {
                    value: "answers.no",
                    description: "results.4-2-1.no",
                    next: "steps.4-2-2"
                },
            ], 
        },
        "steps.4-2-2": {
            type: "answer",
            base_value: "",
            name: "steps.4-2-2",

            questions: [
                {
                    name: "questions.4-2-2",
                    answers: [
                        {
                            name: "answers.yes",
                            value: 1,
                        },
                        {
                            name: "answers.no",
                            value: 0
                        }
                    ]
                }
            ],

            results: [
                {
                    value: "answers.yes",
                    description: "results.4-2-2.yes",
                    next: "steps.4-2-3"
                },
                {
                    value: "answers.no",
                    description: "results.4-2-2.no",
                    next: "steps.4-2-3"
                },
            ], 
        },
        "steps.4-2-3": {
            type: "answer",
            base_value: "",
            name: "steps.4-2-3",

            questions: [
                {
                    name: "questions.4-2-3",
                    answers: [
                        {
                            name: "answers.yes",
                            value: 1,
                        },
                        {
                            name: "answers.no",
                            value: 0
                        }
                    ]
                }
            ],

            results: [
                {
                    value: "answers.yes",
                    description: "results.4-2-3.yes",
                    next: "steps.4-2-4"
                },
                {
                    value: "answers.no",
                    description: "results.4-2-3.no",
                    next: "steps.4-2-4"
                },
            ], 
        },
        "steps.4-2-4": {
            type: "answer",
            base_value: "",
            name: "steps.4-2-4",

            questions: [
                {
                    name: "questions.4-2-4",
                    answers: [
                        {
                            name: "answers.yes",
                            value: 1,
                        },
                        {
                            name: "answers.no",
                            value: 0
                        }
                    ]
                }
            ],

            results: [
                {
                    value: "answers.yes",
                    description: "results.4-2-4.yes",
                    next: "steps.4-2-5"
                },
                {
                    value: "answers.no",
                    description: "results.4-2-4.no",
                    next: "steps.4-2-5"
                },
            ], 
        },
        "steps.4-2-5": {
            type: "answer",
            base_value: "",
            name: "steps.4-2-5",

            questions: [
                {
                    name: "questions.4-2-5",
                    answers: [
                        {
                            name: "answers.yes",
                            value: 1,
                        },
                        {
                            name: "answers.no",
                            value: 0
                        }
                    ]
                }
            ],

            results: [
                {
                    value: "answers.yes",
                    description: "results.4-2-5.yes",
                    next: "steps.4-2-6"
                },
                {
                    value: "answers.no",
                    description: "results.4-2-5.no",
                    next: "steps.4-2-6"
                },
            ], 
        },
        "steps.4-2-6": {
            type: "answer",
            base_value: "",
            name: "steps.4-2-6",

            questions: [
                {
                    name: "questions.4-2-6",
                    answers: [
                        {
                            name: "answers.yes",
                            value: 1,
                        },
                        {
                            name: "answers.no",
                            value: 0
                        }
                    ]
                }
            ],

            results: [
                {
                    value: "answers.yes",
                    description: "results.4-2-6.yes",
                    next: "steps.5-1"
                },
                {
                    value: "answers.no",
                    description: "results.4-2-6.no",
                    next: "steps.5-1"
                },
            ], 
        },
        "steps.5-1": {
            type: "answer",
            base_value: "",
            name: "steps.5-1",

            questions: [
                {
                    name: "questions.5-1",
                    answers: [
                        {
                            name: "answers.yes",
                            value: 1,
                        },
                        {
                            name: "answers.no",
                            value: 0
                        }
                    ]
                }
            ],

            results: [
                {
                    value: "answers.yes",
                    description: "results.5-1.yes",
                    next: "steps.5-2"
                },
                {
                    value: "answers.no",
                    description: "results.5-1.no",
                    next: "steps.5-2"
                },
            ], 
        },
        "steps.5-2": {
            type: "answer",
            base_value: "",
            name: "steps.5-2",

            questions: [
                {
                    name: "questions.5-2",
                    answers: [
                        {
                            name: "answers.yes",
                            value: 1,
                        },
                        {
                            name: "answers.no",
                            value: 0
                        }
                    ]
                }
            ],

            results: [
                {
                    value: "answers.yes",
                    description: "results.5-2.yes",
                    next: "steps.5-3"
                },
                {
                    value: "answers.no",
                    description: "results.5-2.no",
                    next: "steps.5-3"
                },
            ], 
        },
        "steps.5-3": {
            type: "answer",
            base_value: "",
            name: "steps.5-3",

            questions: [
                {
                    name: "questions.5-3",
                    answers: [
                        {
                            name: "answers.yes",
                            value: 1,
                        },
                        {
                            name: "answers.no",
                            value: 0
                        }
                    ]
                }
            ],

            results: [
                {
                    value: "answers.yes",
                    description: "results.5-3.yes",
                    next: "end"
                },
                {
                    value: "answers.no",
                    description: "results.5-3.no",
                    next: "end"
                },
            ], 
        },

    },
                                  
}

